import { useRuntimeConfig } from 'virtual:runtime-config';

import { client } from './experience/client.gen';

export const useExperienceClient = () => {
  const { VITE_RUNTIME_API_URL } = useRuntimeConfig()['seo-category-listing'];

  if (client.getConfig().baseUrl !== VITE_RUNTIME_API_URL) {
    client.setConfig({ baseUrl: VITE_RUNTIME_API_URL });
  }

  return client;
};
